'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var _extends = _interopDefault(require('@babel/runtime/helpers/extends'));
var _objectWithoutProperties = _interopDefault(require('@babel/runtime/helpers/objectWithoutProperties'));
var _classCallCheck = _interopDefault(require('@babel/runtime/helpers/classCallCheck'));
var _createClass = _interopDefault(require('@babel/runtime/helpers/createClass'));
var _possibleConstructorReturn = _interopDefault(require('@babel/runtime/helpers/possibleConstructorReturn'));
var _getPrototypeOf = _interopDefault(require('@babel/runtime/helpers/getPrototypeOf'));
var _inherits = _interopDefault(require('@babel/runtime/helpers/inherits'));
var _assertThisInitialized = _interopDefault(require('@babel/runtime/helpers/assertThisInitialized'));
var _defineProperty = _interopDefault(require('@babel/runtime/helpers/defineProperty'));
var PropTypes = require('prop-types');
var React = require('react');
var server = require('react-dom/server');
var ReactIs = require('react-is');
var Babel = require('@babel/standalone');
var merge = _interopDefault(require('deepmerge'));
var isEqual = _interopDefault(require('react-fast-compare'));

var resolverId = "__resolverFn__";

var createVariableDeclaration = function createVariableDeclaration(t, specifier, source) {
  return t.variableDeclaration("const", [t.variableDeclarator(t.identifier(specifier.local.name), t.callExpression(t.identifier(resolverId), [t.stringLiteral(source.value)]))]);
};

var createDeclaration = function createDeclaration(t, specifier, source) {
  return t.variableDeclaration("const", [t.variableDeclarator(t.identifier(specifier.local.name), t.memberExpression(t.callExpression(t.identifier(resolverId), [t.stringLiteral(source.value)]), t.identifier(specifier.imported.name)))]);
};

var importResolverPlugin = function importResolverPlugin(_ref) {
  var t = _ref.types;
  return {
    visitor: {
      ImportDeclaration: function ImportDeclaration(path) {
        var declarations = path.node.specifiers.reduce(function (acc, specifier) {
          if (t.isImportDefaultSpecifier(specifier) || t.isImportNamespaceSpecifier(specifier)) {
            acc.push(createVariableDeclaration(t, specifier, path.node.source));
          }

          if (t.isImportSpecifier(specifier)) {
            acc.push(createDeclaration(t, specifier, path.node.source));
          }

          return acc;
        }, []);
        path.replaceWithMultiple(declarations);
      }
    }
  };
};

var exportToIifePlugin = function exportToIifePlugin(_ref) {
  var t = _ref.types;
  return {
    visitor: {
      ExportDefaultDeclaration: function ExportDefaultDeclaration(path) {
        var program = path.find(function (parentPath) {
          return parentPath.isProgram();
        });
        var declaration = path.node.declaration;

        if (t.isClassDeclaration(declaration)) {
          path.replaceWith(declaration);

          if (declaration.id === null) {
            throw new Error("`export default class {}` is not supported");
          }

          program.pushContainer("body", [t.returnStatement(t.identifier(declaration.id.name))]);
          return;
        }

        if (t.isIdentifier(declaration)) {
          program.pushContainer("body", [t.returnStatement(t.identifier(declaration.name))]);
          path.remove();
        }
      },
      Program: {
        exit: function exit(path) {
          path.stop();
        }
      }
    }
  };
};

// @ts-ignore There are no types for "@babel/standalone" :(

var registerBabelPlugin = function registerBabelPlugin(pluginName, pluginFunction) {
  if (!Babel.availablePlugins[pluginName]) {
    Babel.registerPlugin(pluginName, pluginFunction);
  }
};

registerBabelPlugin("export-to-iife", exportToIifePlugin);
registerBabelPlugin("import-resolver", importResolverPlugin);
var useBabelConfig = function useBabelConfig(config) {
  var latestConfig = React.useRef();
  var mergedConfig = React.useRef({});

  if (!isEqual(latestConfig.current, config)) {
    latestConfig.current = config;
    mergedConfig.current = merge({
      plugins: ["import-resolver", "export-to-iife"],
      presets: ["react"]
    }, config);
  }

  return mergedConfig.current;
};
var useBabelTransform = function useBabelTransform(config, source) {
  try {
    var mergedConfig = useBabelConfig(config);
    var transformed = React.useMemo(function () {
      return Babel.transform(source, mergedConfig).code;
    }, [source, mergedConfig]);
    return {
      error: null,
      transformed: transformed
    };
  } catch (error) {
    return {
      error: error,
      transformed: ""
    };
  }
};

var hmrId = 0;

if (process.env.NODE_ENV !== "production") {
  if (module.hot) {
    module.hot.addStatusHandler(function (status) {
      if (status === "idle") {
        hmrId += 1;
      }
    });
  }
}

var useHMRId = function useHMRId(enabled) {
  return enabled ? hmrId : 0;
};

/**
 * Evaluates passed source code, uses passed resolver to resolve imports.
 */

var useEvalSourceCode = function useEvalSourceCode(hot, source, resolver) {
  var hmrId = useHMRId(hot);
  return React.useMemo(function () {
    return new Function(resolverId, source)(resolver);
  }, [hmrId, source, resolver]);
};
/**
 * Creates a valid React Component from source.
 */

var useCreateComponentFromSource = function useCreateComponentFromSource(babelConfig, hot, source, resolver) {
  var _useBabelTransform = useBabelTransform(babelConfig, source),
      error = _useBabelTransform.error,
      transformed = _useBabelTransform.transformed;

  var component = useEvalSourceCode(hot, transformed, resolver); // We have to rethrow error because in other case we will break hooks stack

  if (error) {
    throw error;
  }

  if (ReactIs.isValidElementType(component)) {
    return component;
  }

  throw new Error("Render: your source should have a default export with a React component");
};

var useResolveHandler = function useResolveHandler(resolver, context) {
  var latestResolver = React.useRef(resolver);
  var latestContext = React.useRef(context);
  latestResolver.current = resolver;
  latestContext.current = context;
  return React.useCallback(function (importName) {
    return latestResolver.current(importName, latestContext.current);
  }, []);
};

var useRenderElement = function useRenderElement(options) {
  var babelConfig = options.babelConfig,
      source = options.source,
      renderHtml = options.renderHtml,
      resolver = options.resolver,
      resolverContext = options.resolverContext,
      unstable_hot = options.unstable_hot,
      wrap = options.wrap,
      rest = _objectWithoutProperties(options, ["babelConfig", "source", "renderHtml", "resolver", "resolverContext", "unstable_hot", "wrap"]);

  var handleResolve = useResolveHandler(resolver, resolverContext);
  var latestElement = React.useRef(null);
  var latestMarkup = React.useRef("");

  try {
    var component = useCreateComponentFromSource(babelConfig, unstable_hot, source, handleResolve);
    latestElement.current = React.createElement(component, rest);
    latestMarkup.current = renderHtml ? server.renderToStaticMarkup(wrap(latestElement.current)) : '';
    return {
      element: latestElement.current,
      markup: latestMarkup.current,
      error: null
    };
  } catch (error) {
    return {
      element: latestElement.current,
      markup: latestMarkup.current,
      error: error
    };
  }
};

var ComponentRender = function ComponentRender(props) {
  var fallbackElement = props.fallbackElement,
      runtimeError = props.runtimeError;

  var _useRenderElement = useRenderElement(props),
      element = _useRenderElement.element,
      markup = _useRenderElement.markup,
      compilerError = _useRenderElement.error;

  var error = runtimeError || compilerError;
  React.useEffect(function () {
    if (!error) {
      fallbackElement.current = React.cloneElement(element);
    }
  });
  return props.children({
    element: error ? fallbackElement.current : element,
    error: error,
    markup: markup
  });
};

var SourceRender =
/*#__PURE__*/
function (_React$Component) {
  _inherits(SourceRender, _React$Component);

  function SourceRender() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, SourceRender);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(SourceRender)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "state", {
      error: null,
      source: ''
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "fallbackElement", React.createRef());

    return _this;
  }

  _createClass(SourceRender, [{
    key: "render",
    value: function render() {
      var _ref = this.props,
          wrap = _ref.wrap,
          rest = _objectWithoutProperties(_ref, ["wrap"]);

      var error = this.state.error;
      return wrap(React.createElement(ComponentRender, _extends({}, rest, {
        fallbackElement: this.fallbackElement,
        runtimeError: error,
        wrap: wrap
      })));
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(props, state) {
      return {
        source: props.source,
        error: props.source === state.source ? state.error : null
      };
    }
  }, {
    key: "getDerivedStateFromError",
    value: function getDerivedStateFromError(error) {
      return {
        error: error
      };
    }
  }]);

  return SourceRender;
}(React.Component);

_defineProperty(SourceRender, "propTypes", {
  babelConfig: PropTypes.object,
  children: PropTypes.func.isRequired,
  renderHtml: PropTypes.bool,
  resolver: PropTypes.func.isRequired,
  resolverContext: PropTypes.object,
  source: PropTypes.string.isRequired,
  unstable_hot: PropTypes.bool,
  wrap: PropTypes.func
});

_defineProperty(SourceRender, "defaultProps", {
  babelConfig: {},
  renderHtml: true,
  resolverContext: {},
  unstable_hot: false,
  wrap: function wrap(children) {
    return children;
  }
});

exports.default = SourceRender;
